var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"print"},[_c('PrintContent',{staticClass:"seen",attrs:{"data":_vm.data}}),_c('PrintContent',{ref:"printable",staticClass:"unseen",attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }